var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Component } from '@angular/core';
import { WorkloadReportType } from '../../../../enums/workload/report-type';
import { EnumUtil } from '../../../../enums/enum-util';
import { WorkloadReportService } from '../../../../services/workload/workload-report-service';
var ReportsComponent = /** @class */ (function () {
    function ReportsComponent(reportService) {
        this.reportService = reportService;
        this.lineChartOptions = {
            responsive: true
        };
        this.lineChartColors = [
            {
                backgroundColor: 'rgba(77,83,96,0)',
                borderColor: '#36cdcd',
                pointBackgroundColor: '#fff',
                pointBorderColor: '#36cdcd',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#36cdcd',
                borderWidth: 2
            },
            {
                backgroundColor: 'rgba(148,159,177,0)',
                borderColor: '#f00',
                pointBackgroundColor: '#fff',
                pointBorderColor: '#f00',
                pointHoverBackgroundColor: '#fff',
                pointHoverBorderColor: '#f00',
                borderWidth: 2
            }
        ];
        this.lineChartLegend = true;
        this.viewModel = {
            sectionHeaders: {
                startDate: 'Start Date',
                endDate: 'End Date',
                reportType: 'Report Type'
            },
            placeHolders: {
                startDate: 'Select a start date',
                endDate: 'Select an end date',
                reportType: 'Select a report type'
            },
            formData: {
                startDate: null,
                endDate: null,
                reportType: WorkloadReportType.NotSet
            },
            reportTypes: EnumUtil.toArray(WorkloadReportType).map(function (x) { return x.id; }),
            graphData: null
        };
    }
    ReportsComponent.prototype.buildGraph = function () {
        return __awaiter(this, void 0, void 0, function () {
            var reportPeriod;
            return __generator(this, function (_a) {
                if (this.viewModel.formData.startDate && this.viewModel.formData.endDate &&
                    this.viewModel.formData.startDate < this.viewModel.formData.endDate &&
                    this.viewModel.formData.reportType !== WorkloadReportType.NotSet) {
                    reportPeriod = {
                        startDate: this.viewModel.formData.startDate,
                        endDate: this.viewModel.formData.endDate
                    };
                    switch (+this.viewModel.formData.reportType) {
                        case WorkloadReportType.DueVsOverdue:
                            {
                                this.viewModel.graphData = this.reportService.dueVsOverdue(reportPeriod).toPromise();
                                break;
                            }
                        case WorkloadReportType.UploadedToSA:
                            {
                                this.viewModel.graphData = this.reportService.uploadedToStandardsApproval(reportPeriod).toPromise();
                                break;
                            }
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    ReportsComponent.prototype.typeSelected = function (type) {
        this.viewModel.formData.reportType = type;
    };
    ReportsComponent = __decorate([
        Component({
            selector: 'app-reports',
            template: require('./reports.component.html'),
            styles: [require('./reports.component.scss')]
        }),
        __metadata("design:paramtypes", [WorkloadReportService])
    ], ReportsComponent);
    return ReportsComponent;
}());
export { ReportsComponent };
//# sourceMappingURL=data:application/json;base64,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